import React  from 'react';
import {Box, Divider, Grid, Hidden} from '@mui/material';
import AdUI from "../../../ui-component/AdUI";

function Sidebar() {
    return (
        <Hidden only={['xs', 'sm']}>
            <Grid item xs md={3}>
                <Box my={4} style={{ position: 'sticky', top: '1rem' }}>
                    <div style={{textAlign: "center", zIndex: 1}}>
                        <AdUI format="horizontal"/>
                        <AdUI format="vertical"/>
                    </div>
                </Box>
            </Grid>
        </Hidden>
    );
}

export default Sidebar;